import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import WoocommerceAPI from '../../../IPSAPI/WoocommerceAPI';
import SkeletonContentV2 from '../../../Skeleton/SkeletonContentV2';
import { RootState } from '../../../../redux/checkoutredux/store/checkoutStore';

interface ContentElementV2Props {
  setTotal?: React.Dispatch<React.SetStateAction<number>>;
  setTotalFormat?: React.Dispatch<React.SetStateAction<string>>;
  setQuantity?: React.Dispatch<React.SetStateAction<number>>;
  loading: boolean;
  currentProductId: string[];
  setCurrentProductId: React.Dispatch<React.SetStateAction<string[]>>;
  currentCartKeyId?: string[];
  setCurrentCartKeyId?: React.Dispatch<React.SetStateAction<string[]>>;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
}
const ContentElementV2: React.FC<ContentElementV2Props> = ({
  setTotal,
  setTotalFormat,
  setQuantity,
  loading,
  currentProductId,
  setCurrentProductId,
}) => {
  const settings = useSelector((state: RootState) => state.sidecartsettings.appSettings || null);
  const cartItems = useSelector((state: RootState) => state.shoppingcart.productdata || []);
  const [isConditionMet, setIsConditionMet] = useState(false);

  const handleRemoveFromCart = async (productKey: string, productId: string) => {
    try {
      setCurrentProductId([productId]);
      await WoocommerceAPI.ajax_removeFromCart(settings.base_url, productKey);
    } catch (error) {
      console.error('Error removing product from cart:', error);
    }
  };

  useEffect(() => {
    const cartItemsFromStorage = JSON.parse(localStorage.getItem('ips_cart_items') || '[]');
    if (cartItemsFromStorage.length === 0) {
      setQuantity(0);
      setTotal(0);
      setTotalFormat('');
    } else {
      setQuantity(cartItemsFromStorage[0].quantityall || 0);
      setTotal(cartItemsFromStorage[0].totalprice || 0);
      setTotalFormat(cartItemsFromStorage[0].totalpriceformat || '');
    }
  }, [setQuantity, setTotal, setTotalFormat]);

  useEffect(() => {
    if (cartItems.length > 0 && currentProductId.length > 0 && loading) {
      const conditionMet = cartItems.some(
        (product) => parseInt(currentProductId[0]) === parseInt(product.id)
      );
      setIsConditionMet(conditionMet);
    } else {
      setIsConditionMet(false);
    }
  }, [cartItems, currentProductId, loading]);

  return (
    <div className="content-element">
      {cartItems.map((product) => (
        <div className="row py-2 ips-item-row" key={product.id}>
          {currentProductId.length > 0 && parseInt(currentProductId[0]) === parseInt(product.id) && loading ? (
            <div>
              <SkeletonContentV2 settings={settings} />
            </div>
          ) : (
            <>
              <div
                className="d-flex justify-content align-items-center col-2 mt-1 mb-1 my-auto ips_orderimgmobile"
                dangerouslySetInnerHTML={{ __html: product.product_image }}
              ></div>
              <div className="col-9 mt-1">
                <div className="d-flex flex-row ips-contentelemt-titleview2">{product.name}</div>
                {product.variationset && Array.isArray(product.variationset) && (
                  <div>
                    {product.variationset.map((variation, index) => (
                      <div
                        key={index}
                        className="d-flex flex-row ips-contentelement-variationview2"
                        dangerouslySetInnerHTML={{ __html: variation }}
                      />
                    ))}
                  </div>
                )}
                {product.deliverytime && (
                  <div
                    className="d-flex flex-row ips-variation-deliverytime"
                    dangerouslySetInnerHTML={{ __html: product.deliverytime }}
                  />
                )}
                <div className="d-flex ips-flex-row flex-row ips-contentelement-quantityview2">
                  <span
                    dangerouslySetInnerHTML={{
                      __html: `${product.quantity} x <span class="ips-contentprice-view2">${product.priceinctaxformat}</span>`,
                    }}
                  />
                </div>
                <div className="d-flex flex-row ips-taxrate-view2">{product.taxrate}</div>
              </div>
              <input
                type="hidden"
                className="ips_wooadd_cat"
                data-cat={product.allcategories}
                data-catids={product.allcategorieids}
                name="ips_woo_cat"
              ></input>
              <div className="justify-content align-items-center px-0 col-1 mt-1 mb-1 my-auto">
                <div className="d-flex ips-remove-btnselect flex-row">
                  <div
                    className="ips-sidecart-remove-contentbtn-view2"
                    onClick={() => handleRemoveFromCart(product.key, product.id)}
                  ></div>
                </div>
              </div>
            </>
          )}
        </div>
      ))}
      {!isConditionMet && loading && (
        <div>
          <SkeletonContentV2 settings={settings} />
        </div>
      )}
    </div>
  );
};

export default ContentElementV2;